/*** IMPORTS FROM imports-loader ***/
var define = false;

export default class Menu {

    init() {
        this._addArrowSubMenu();

        // Делаем размер ul меньше если размер изображения в меню 2x
        $(".main-menu__item--parent").hover(function () {
            var sizePicInMenu = $(this).find(".sub-menu__item--pic").width();

            if (sizePicInMenu > 170) {
                $(this).find(".sub-menu__item--ul").addClass("sub-menu__item--small");
            }
        });

        this._showHideAdaptiveMenu();
    }

    _addArrowSubMenu() {
        $(".sub-menu__item").closest(".main-menu__item").addClass("main-menu__item--parent");
    }

    _showHideAdaptiveMenu() {
        $(".burger").click(function () {
            $(this).toggleClass("burger--active");
            $(".main-menu").toggleClass("main-menu--active");
            $(".header").toggleClass("header--scroll");
        });

        $(".main-menu__click-adaptive").click(function () {
            $(this).parent().toggleClass("main-menu__item--active");
        });
    }
}



// WEBPACK FOOTER //
// ./app/Sites/AT/assets/js/modules/Menu.js